import { render, staticRenderFns } from "./OwnersAssociationHeader.vue?vue&type=template&id=2ffd43ce&scoped=true&"
import script from "./OwnersAssociationHeader.vue?vue&type=script&lang=js&"
export * from "./OwnersAssociationHeader.vue?vue&type=script&lang=js&"
import style0 from "./OwnersAssociationHeader.vue?vue&type=style&index=0&id=2ffd43ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffd43ce",
  null
  
)

export default component.exports